import SvgChevron from '@img/icons/chevron-right.svg';
import Button from '@stories/Components/Global/Buttons/Button/Button';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import { getQuickLinkIcon } from '../../Header';
import S from '../MobileNavigation.styles';
const NavigationLinkList = (props) => {
    return (React.createElement(S.NavigationMenu, { "aria-active": props.active, variants: {
            hidden: { opacity: 0, x: `101%`, transitionEnd: { display: 'none' } },
            visible: { opacity: 1, x: 0, display: 'flex' },
        }, initial: "hidden", animate: props.active ? 'visible' : 'hidden', transition: { duration: 0.5, ease: [0.33, 1, 0.68, 1] } },
        props.isChild && (React.createElement(S.BackButtton, null,
            React.createElement(Button, { buttonType: "outline-alt", onClick: props.onClickBack, site: props.site }, "Back"))),
        React.createElement(S.LinkList, null,
            props.label && React.createElement(S.LinkListItem, { "data-label": true }, props.label),
            props.links.map((link) => (React.createElement(S.LinkListItem, { key: `mobile-${link.id}` },
                React.createElement(S.Link, { ...(link.children.length > 0
                        ? { as: 'button', onClick: () => props.onClick(link.id) }
                        : { href: link.url, target: link.target }) },
                    link.text,
                    " ",
                    React.createElement(SvgChevron, null)))))),
        React.createElement(LinkButton, { buttonType: "default", icon: getQuickLinkIcon(props.cta.icon), iconPosition: "left", href: props.cta.url, target: props.cta.target, site: props.site }, props.cta.text)));
};
export default NavigationLinkList;
